module.exports = __webpack_public_path__ + "static/media/galerija_2014 (12).fe4514a0.jpg";